import {styles as inputBaseStyles} from '@material-ui/core/InputBase/InputBase';
import withStyles from '@material-ui/core/styles/withStyles';
import * as React from 'react';

const ReadOnly = withStyles(inputBaseStyles)(({children, classes, className, ...props}) => <span {...props}>{children}</span>);

export default ReadOnly;
